import React, {useState} from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsMore from "highcharts/highcharts-more";
import {currencyFormat, updateChartTheme} from "../../../utils/helpsers";

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
HighchartsMore(Highcharts);

/**
 * Line chart using highcharts library.
 * @param data {object} The series to draw the lines in the chart.
 * @param labelPoints {boolean} Enable label point on the chart
 * @param chartHeight { string|number} The height for the chart, auto is the default value.
 * @param title {string} The title of the chart is displayed on top.
 * @param max {number} The maximum of steps in the X axis of the chart
 * @param currencyValue {boolean} Check if the value is a currency  
 * @return {JSX.Element}
 * @constructor
 */
const LineChart = ({data, labelPoints = true, chartHeight = "auto", title = "Historical Data", max = undefined, currencyValue = false}) => {
  const [showRawDataTable, setShowRawDataTable] = useState(false);
  const chartData = {
    chart: {
      type: 'line',
      height: chartHeight,
      backgroundColor: '#fff',
    },
    title: {
      text: title
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      categories: data[0] ? data[0].years : [],
      max: max,
      title: {
        text: 'School Cycle'
      },
    },
    tooltip: {
      formatter: function () {
        return `${this.series.name}: <strong>${currencyValue ? currencyFormat(this.point.y) : this.point.y}</strong>`;
      }
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: labelPoints
        },
        enableMouseTracking: true
      }
    },
    legend: {
      maxHeight: 100  
    },
    exporting: {
      tableCaption: false,
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            {
              text: "Toggle Light/Dark mode",
              onclick: function () {
                updateChartTheme(this);
              }
            },
            {
              separator: true,
            },
            {
              text: "Download PDF document",
              onclick: function () {
                this.exportChart({
                  type: "application/pdf",
                });
              },
            },
            {
              text: "Download CSV",
              onclick: function () {
                this.downloadCSV();
              },
            },
            {
              text: "Download XLS",
              onclick: function () {
                this.downloadXLS();
              },
            },
            {
              separator: true,
            },
            {
              text: showRawDataTable ? "Hide Raw Data Table" : "Show Raw Data Table",
              onclick: function () {

                if (showRawDataTable) {
                  setShowRawDataTable(!showRawDataTable);
                  this.hideData();

                } else {
                  setShowRawDataTable(!showRawDataTable);
                  this.viewData()
                }
              }
            }
          ],
        },
      },
    },
    series: data
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={chartData}
    />
  )
}

export default  React.memo(LineChart);
